export default __webpack_public_path__ + "static/media/logo.b9c58cff.jpeg";